import React,{useContext} from "react";
import moment from "moment";
import "moment/locale/es";

import { makeStyles } from "@material-ui/core/styles";
import Card from "@material-ui/core/Card";
import CardActions from "@material-ui/core/CardActions";
import CardContent from "@material-ui/core/CardContent";
import Link from "@material-ui/core/Link";
import Typography from "@material-ui/core/Typography";

import useMediaQuery from "../../hooks/useMediaQuery";
import AuthContext from "../../context/authentication/authContext";

import "./InfinityScroll.css";


const useStyles = makeStyles({
  root: {
    width: "90%",
    marginLeft: "10px",
    marginTop: "20px",
    marginBottom: "20px",
    marginRight: "10px",
    font: "normal normal medium 20px/24px Roboto;",
  },
  bullet: {
    display: "inline-block",
    margin: "0 2px",
    transform: "scale(0.8)",
  },
  componentTitle: {
    fontSize: 18,
    padding: 10,
  },
  date:{
    fontSize: 12,
    color: "#12B1EE",
  },
  title: {
    fontSize: 18,
    color: "#12B1EE",
  },
  excerpt: {
    fontSize: 14,
    color: "#12B1EE",
  },

  pos: {
    marginBottom: 12,
    width: "100%",
    whiteSpace: "pre-wrap",
  },
  actions: {
    justifyContent: "center",
    alignItems: "center",
    textAlign: "center",
  },
});

const InfinityScroll = (props) => {

  const authContext = useContext(AuthContext)
  const { news ,getTheNews } = authContext
  const classes = useStyles();

  const isMobile = useMediaQuery("max-width", 600);
  moment.locale("es");

  React.useEffect(()=>{getTheNews()},[])
  return (
    <>
      <div
        style={{
          overflowX: isMobile && "scroll",
          overflowY: !isMobile && "hidden",
          whiteSpace: "nowrap",
        }}
      >
        { news && news.map((noticia, index) => (
          <div
            key={index}
            style={{ display: isMobile ? "inline-block" : "block" }}
          >
            <Card className={classes.root}>
              <CardContent>
                <Typography
                  className={classes.date}
                  //color="textSecondary"
                  gutterBottom
                >
                  {moment(noticia.date).format("dddd DD MMMM YYYY")}
                </Typography>
                <Typography variant="h5" align="justify" component="h2">
                  {noticia.title}
                </Typography>
                <Typography variant="subtitle2" align="justify" style={{whiteSpace:'normal', wordBreak:'break-word'}} component="div">
                  {noticia.subTitle}
                </Typography>
                <Typography className={classes.pos} color="textSecondary">
                  {noticia.description}
                </Typography>
                {/* <Typography variant="body2" component="p">
                  body2
                </Typography> */}
              </CardContent>
              <CardActions className={classes.actions}>
                <Link href={noticia.buttonLink} target="_blank" variant="body2">
                  <span>VER MAS</span>
                </Link>
              </CardActions>
            </Card>
          </div>
        ))}
      </div>
    </>
  );
};

export default InfinityScroll;
